import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Sparkline } from "./Sparkline";
import { formatINR, formatPercent, signColor, healthClass } from "../lib/format";

export const CompanyCard = ({ c }) => {
  const up = c.change_percent >= 0;
  return (
    <Link
      to={`/company/${c.ticker}`}
      data-testid={`company-card-${c.ticker.toLowerCase()}`}
      className="lv-panel lv-panel-hover group flex flex-col gap-3 p-4 transition-transform duration-200 hover:-translate-y-0.5"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-mono text-sm font-semibold text-white">{c.ticker}</span>
            <span className="rounded border border-white/10 px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-wider text-zinc-500">
              {c.cap_label}
            </span>
          </div>
          <p className="mt-1 truncate text-xs text-zinc-400">{c.name}</p>
        </div>
        <ArrowUpRight className="h-4 w-4 shrink-0 text-zinc-600 transition-colors group-hover:text-amber-400" />
      </div>

      <div className="flex items-end justify-between gap-3">
        <div>
          <div className="font-mono text-base font-semibold text-white tabular-nums">{formatINR(c.price)}</div>
          <div className={`font-mono text-xs ${signColor(c.change_percent)}`}>{formatPercent(c.change_percent)}</div>
        </div>
        <div className="h-9 w-24">
          <Sparkline data={c.sparkline} color={up ? "#10B981" : "#F43F5E"} height={36} />
        </div>
      </div>

      <div className="mt-1 flex items-center gap-2 border-t border-white/[0.06] pt-3">
        <span className={`rounded border px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-wide ${healthClass(c.health_status)}`}>
          {c.health_status}
        </span>
      </div>

      <div className="rounded-md border border-amber-500/15 bg-amber-500/[0.05] px-2.5 py-2">
        <p className="kicker mb-0.5 text-amber-500/70">Why it's here</p>
        <p className="text-[11px] leading-snug text-amber-100/80">{c.discover_reason}</p>
      </div>
    </Link>
  );
};
